import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper';

const Slider = ({ items }) => {
  
  const [favorites, setFavorites] = useState(
    items.map(() => false) // Initialize all as false (not liked)
  );

  const handleLikeClick = (index) => {
    const updatedFavorites = [...favorites];
    updatedFavorites[index] = !updatedFavorites[index]; // Toggle like status for that item
    setFavorites(updatedFavorites);
  };
  

  // Ref for Swiper instance
  const swiperRef = useRef(null);
  
  // State to track the active slide index for custom pagination
  const [activeSlide, setActiveSlide] = useState(0);

  // Handle slide change event and update activeSlide state
  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper.activeIndex);
  };

  // Handle click on custom pagination dot
  const handleDotClick = (index) => {
    swiperRef.current.swiper.slideTo(index);  // Move Swiper to the clicked slide
    setActiveSlide(index);  // Update the active slide state
  };

  return (
    <div className="favorite-slider ">
      <Swiper
        spaceBetween={0}
        pagination={{
          clickable: true,
          el: ".swiper-pagination", // Custom pagination container
        }}
        modules={[Pagination]}
        className="mySwiper"
        onSlideChange={handleSlideChange} // Update activeSlide on slide change
        ref={swiperRef}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
          1200: {
            slidesPerView: 5,
          },
        }}
      >
        {items.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="extraa">
              <div className="exchange">
                <div className="central-slider" onClick={() => item}>
                  <div className="card-header">
                    <div>
                      <div className="icon">
                        <img src={item.cardHeaderIcon} alt="header icon" />
                      </div>
                      <h2>{item.cardHeaderTitle}</h2>
                    </div>
                    <div>
                      <button
                        className="like-unlike-button"
                        onClick={() => handleLikeClick(index)}
                      >
                        <img
                          src={favorites[index] ? "/like.svg" : "/unlike2.svg"}
                          alt={favorites[index] ? "Unlike" : "Like"}
                        />
                      </button>
                    </div>
                  </div>
                  <div className="card-details">
                    <div className="detail">
                      <span>{item.detailspan1}</span>
                      <span>{item.detailspan1value}</span>
                    </div>
                    <div className="detail highlighted">
                      <span>{item.detailspan2}</span>
                      <span>{item.detailspan2value}</span>
                    </div>
                    <div className="detail">
                      <span>{item.detailspan3}</span>
                      <span>{item.detailspan3value}</span>
                    </div>
                  </div>
                  <div className="card-footer">
                    <div className="trust-score">
                      <div className="trust-score-img">
                        <img src={item.TrustScoreImage} alt="trust score" />
                        <span>{item.trustScoreSpan}</span>
                      </div>
                      <span className="score">{item.trustScoreSpanValue}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Custom Pagination */}
      <div className="swiper-pagination">
        {items.map((_, index) => (
          <div
            key={index}
            className={`pagination-dot ${
              activeSlide === index ? "active" : ""
            }`}
            onClick={() => handleDotClick(index)} // Navigate to the clicked slide
            style={{
              width: "12px",
              height: "12px",
              borderRadius: "50%",
              backgroundColor: activeSlide === index ? "#007bff" : "#ccc",
              margin: "0 8px",
              cursor: "pointer",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;
